import React, { useState } from "react";
import { Checkbox, Button, Collapse } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateEmployee } from "../../Slices/Thunk/employeeThunk";
import { useParams } from "react-router-dom";
import { SideMenu } from "../../Slices/employeeslice";
import { SIDEMENU } from "../../databucket";
import { message } from "antd";
import { updateSidebarData } from "./updateSidebarData"
import { setLoader } from "../../Slices/loaderSlice";
const { Panel } = Collapse;
const ConditionMenu = () => {
  const dispatch = useDispatch();
  const { Empid } = useParams();
  const [submitState, setSubmitState] = useState(false)
  const ids = Empid
  const initialSidemenu = useSelector((state) => state.employee.sidemenu);
  const loginUserRole = useSelector((state) => state?.loginUserInfo?.loginUserDetails.role);
  const userRole = useSelector((state) => state.employee.userData.role);
  const Routes = initialSidemenu ? updateSidebarData(SIDEMENU, initialSidemenu) : SIDEMENU

  const [sidemenu, setSidemenu] = useState(Routes);
  const [changes, setChanges] = useState(false);
  const maxSubroutes = Math?.max(
    ...sidemenu?.map((menu) => (menu.Subfields ? menu.Subfields.length : 0))
  );
  const toggleSidemenuStatus = (index, subIndex = null) => {
    setChanges(true);
    const updatedSidemenu = sidemenu?.map((menu, i) => {
      if (i === index) {
        if (subIndex === null) {
          const newStatus = !menu.status;
          return {
            ...menu,
            status: newStatus,
            key: newStatus,
            Subfields: menu.Subfields
              ? menu.Subfields?.map((sub) => ({
                ...sub,
                status: newStatus,
                key: newStatus,
              }))
              : [],
          };
        } else {
          const updatedSubfields = menu.Subfields?.map((sub, sIndex) =>
            sIndex === subIndex
              ? { ...sub, status: !sub.status, key: !sub.status } // Toggle subfield status & key
              : sub
          );
          const allSubfieldsUnchecked = updatedSubfields?.every(sub => !sub.status);
          const updatedMenu = {
            ...menu,
            Subfields: updatedSubfields,
            status: allSubfieldsUnchecked ? false : menu.status, // Uncheck main menu if all subfields are unchecked
            key: allSubfieldsUnchecked ? false : menu.status, // Ensure key follows status
          };

          return updatedMenu;
        }
      }
      return menu;
    });
    setSidemenu(updatedSidemenu);
  };



  const handleSubmit = async () => {
    if (!changes) {
      message.info({
        content: "No Changes Are Detected",
        duration: 5,
      })
      return;
    }
    setSubmitState(true)

    // Define role hierarchy
    const roleHierarchy = {
      "User": 1,
      "Admin": 2,
      "Super Admin": 3,
    };

    // Block if user not allowed to update this role's routes
    if (roleHierarchy[loginUserRole] < roleHierarchy[userRole]) {
      message.error("You are not authorized to update this user's routes.");
      setSubmitState(false);
      return;
    }


    const cleanSubfields = (subfields) => {
      return subfields?.map((subfield) => {
        const { __typename, ...rest } = subfield;
        return rest; // Return cleaned subfield without __typename
      });
    };

    const cleanedSidemenu = sidemenu?.map((item) => {
      const { __typename, Subfields, ...rest } = item;
      const cleanedSubfields = Subfields ? cleanSubfields(Subfields) : [];
      return { ...rest, Subfields: cleanedSubfields };
    });
    try {
      dispatch(setLoader(true));
      const input = { menu: cleanedSidemenu }
      const data = await dispatch(updateEmployee({ id: ids, input }));
      if (data?.payload) {
        dispatch(setLoader(false));
        dispatch(SideMenu(cleanedSidemenu))
        message.success({
          content: "Updated Successfully",
          duration: 5,
          className: 'custom-toast-center',
        });
        setChanges(false);
        setSubmitState(false)
      }
    } catch (error) {
      message.error({
        content: "Failt to update ",
        duration: 5,
        className: 'custom-toast-center',
      });

    } finally {
      setSubmitState(false)
      setChanges(false);
      dispatch(setLoader(false));
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        minHeight: "100vh", // Full viewport height
        backgroundColor: "#f5f5f5", // Optional background color
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "100%", // Optional maximum width to limit size
          padding: "10px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h3 className="card-title" style={{ marginTop: "12px", fontSize: "20px", marginLeft: "10px" }}>
          Manage Routes and Sidemenu
        </h3>

        <div
          style={{
            padding: "10px",
            background: "#fff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <Collapse
            items={sidemenu?.map((menu, index) => ({
              key: index,
              label: (
                <Checkbox
                  checked={menu.status}
                  onChange={() => toggleSidemenuStatus(index)}
                  style={{
                    fontFamily: "serif",
                    fontSize: "16px",
                  }}
                >
                  {menu.name}
                </Checkbox>
              ),
              children: (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  {menu.Subfields &&
                    menu.Subfields.map((sub, subIndex) => (
                      <div
                        key={subIndex}
                        style={{
                          maxWidth: "200px",
                          padding: "5px",
                          display: "flex",
                          alignItems: "center",
                          border: "1px solid #ddd",
                          borderRadius: "5px",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Checkbox
                          checked={sub.status}
                          disabled={!menu.status}
                          onChange={() => toggleSidemenuStatus(index, subIndex)}
                        >
                          {sub.displayName}
                        </Checkbox>
                      </div>
                    ))}

                  {menu.Subfields &&
                    Array(maxSubroutes - menu.Subfields.length)
                      .fill(null)
                      .map((_, emptyIndex) => (
                        <div
                          key={`empty-${emptyIndex}`}
                          style={{
                            visibility: "hidden",
                            maxWidth: "200px",
                            padding: "5px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                          }}
                        >
                          Placeholder
                        </div>
                      ))}
                </div>
              ),
            }))}
          ></Collapse>

        </div>

        <Button
          type="primary"
          onClick={handleSubmit}
          style={{
            marginTop: "20px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          disabled={submitState}
        >
          Submit
        </Button>
      </div>
    </div>


  );
};

export default ConditionMenu;

